/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import safeHtmlId from 'js/lib/safeHtmlId';

import HorizontalLearnerPhotos from 'pages/open-course/peerReview/components/HorizontalLearnerPhotos';
import StackedLearnerPhotos from 'pages/open-course/peerReview/components/StackedLearnerPhotos';
import type { ReviewerDetails } from 'pages/open-course/peerReview/components/types';

import { Radio } from '@coursera/cds-core';

type Props = {
  checked: boolean;
  groupId: string;
  optionId: string;
  reviewers: ReviewerDetails[];
  isAssignmentLevelPart: boolean;
  isAIGraded?: boolean;
  children?: React.ReactNode;
};

const styles = {
  container: () => css`
    display: flex;
    margin-bottom: var(--cds-spacing-200);
  `,
  radio: () => css`
    white-space: nowrap;
  `,
  content: () => css`
    flex-grow: 1;
    padding-top: var(--cds-spacing-100);
  `,
  reviewers: () => css`
    white-space: nowrap;
    padding: var(--cds-spacing-100) 0 0 var(--cds-spacing-100);
  `,
};

const OptionFeedbackRow = (props: Props) => {
  const scopedGroupId = 'OptionFeedbackRow-' + safeHtmlId(props.groupId);
  const scopedOptionId = 'OptionFeedbackRow-' + safeHtmlId(props.groupId) + '-' + safeHtmlId(props.optionId);
  return (
    <div css={styles.container}>
      <div css={styles.radio}>
        <Radio
          disabled={true}
          checked={props.checked}
          name={scopedGroupId}
          aria-labelledby={scopedOptionId}
          label="" // we want the radio button to be disabled but keep the option content regular styled
        />
      </div>
      <div css={styles.content}>
        {props.children}
        {!props.isAIGraded && props.isAssignmentLevelPart && <HorizontalLearnerPhotos learners={props.reviewers} />}
      </div>
      <div css={styles.reviewers}>
        {!props.isAIGraded && !props.isAssignmentLevelPart && <StackedLearnerPhotos learners={props.reviewers} />}
      </div>
    </div>
  );
};

export default OptionFeedbackRow;
